import { PATH } from '@/constants/path';
import useHandleContextual from '@/components/ContextualBar/HideContextual';
import { isShowSelector } from '@/redux/slice/contextualBar.slice';
import { Badge, BadgeProps } from '@shopify/polaris';
import { StarFilledIcon } from '@shopify/polaris-icons';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { config } from '@/config';
import { useTranslation } from 'react-i18next';
import userPlans from '@/hooks/userPlans';

interface CustomBadgeProps extends Omit<BadgeProps, ''> {
  position?: string;
  hasIcon?: boolean;
  marginLeft?: boolean;
  marginRight?: boolean;
}
const CustomBadge = ({ hasIcon = true, marginLeft = true, ...props }: CustomBadgeProps) => {
  const navigate = useNavigate();
  const contextual = useHandleContextual();
  const isShowContextualBar = useSelector(isShowSelector);
  const { t } = useTranslation('pricing');
  const { isUserFreeLimited, isUserBasicLimited } = userPlans();

  const handleRedirectPricing = () => {
    if (isShowContextualBar && config.embedded === '1') {
      contextual.hide();
    } else {
      navigate(PATH.PRICING_PLAN);
    }
  };

  const textForBadge = isUserFreeLimited ? t('paid_plan') : isUserBasicLimited ? t('premium') : t('paid_plan');

  const className = `pointer ${marginLeft ? 'ml-4' : ''} ${props.marginRight ? 'mr-4' : ''}`;

  return (
    <span className={className} onClick={handleRedirectPricing}>
      <Badge icon={hasIcon ? StarFilledIcon : undefined} tone={props.tone || 'info'}>
        {props.children || textForBadge}
      </Badge>
    </span>
  );
};

export default memo(CustomBadge);
